module.exports = __webpack_public_path__ + "img/mailing.c46ea0c8.svg";